import { render, staticRenderFns } from "./ScheduleDetail.vue?vue&type=template&id=3ea507c9&scoped=true"
import script from "./ScheduleDetail.vue?vue&type=script&lang=js"
export * from "./ScheduleDetail.vue?vue&type=script&lang=js"
import style0 from "./ScheduleDetail.vue?vue&type=style&index=0&id=3ea507c9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea507c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea507c9')) {
      api.createRecord('3ea507c9', component.options)
    } else {
      api.reload('3ea507c9', component.options)
    }
    module.hot.accept("./ScheduleDetail.vue?vue&type=template&id=3ea507c9&scoped=true", function () {
      api.rerender('3ea507c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/ScheduleDetail.vue"
export default component.exports